export default __webpack_public_path__ + "static/media/2.9f938f32.png";